import { useMemo }      from 'react';
import { userInfoType } from 'types';

const useGetUserGuestStatus = (
    userInfo: userInfoType,
) => {

    const guest = useMemo(() => {
        // Check multiple indicators for guest status:
        // 1. Email is guest email or empty
        // 2. semelMosad is 'guest' (from PHP response)
        // 3. userFoundInTables includes 'guest_identity' (from PHP response)
        const emailIsGuest = userInfo.userEmail === 'guest@yisumatica.org.il' || userInfo.userEmail === '';
        const semelIsGuest = userInfo.semelMosad === 'guest';
        const foundAsGuest = Array.isArray(userInfo.userFoundInTables) && userInfo.userFoundInTables.includes('guest_identity');
        
        return emailIsGuest || semelIsGuest || foundAsGuest;
      },[userInfo])

    return guest

}

export default useGetUserGuestStatus;